export { default as FeatureShowcase } from "./FeatureShowcase";
export type { FeatureShowcaseProps } from "./FeatureShowcase";
